import { useId } from "react";
import { IconProps } from "@/types/types";

export default function Loading({ width = "32", height = "32", color }: IconProps) {
    const gradientId = useId();

    return (
        <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34 18C34 14.8355 33.0616 11.7421 31.3035 9.11088C29.5454 6.47969 27.0466 4.42893 24.1229 3.21793C21.1993 2.00693 17.9823 1.69007 14.8786 2.30744C11.7749 2.9248 8.92393 4.44865 6.68629 6.68629C4.44865 8.92393 2.9248 11.7749 2.30744 14.8786C1.69007 17.9823 2.00693 21.1993 3.21793 24.1229C4.42893 27.0466 6.47969 29.5454 9.11088 31.3035C11.7421 33.0616 14.8355 34 18 34" stroke={`url(#${gradientId})`} strokeWidth="4" strokeLinecap="round" />
            <defs>
                <linearGradient id={gradientId} x1="18" y1="2" x2="18" y2="34" gradientUnits="userSpaceOnUse">
                    <stop stopColor={color ? color : "#2ABC66"} />
                    <stop offset="1" stopColor={color ? color : "#007377"} />
                </linearGradient>
            </defs>
        </svg>
    )
}

